import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import fb from './fb'

Vue.use(Vuex)

export default new Vuex.Store({
	namespaced: true,
	state: {
		showLoading:false
	},
	modules: {
		user,
		fb
	},
	mutations: {
		req (state,data) {
			state.showLoading = data;
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js